import { FC, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from 'assets/logo.png';
import { useLogout } from '@refinedev/core';
import { IoMdClose } from 'react-icons/io';
import { AiOutlineHome } from 'react-icons/ai';
import { IoIosList } from 'react-icons/io';

interface LayoutProps {
  children: React.ReactNode;
}
const Layout: FC<LayoutProps> = ({ children }) => {
  const ref = useRef(null);

  const [opensidebar, setOpensidebar] = useState(false);
  const { mutate: logout } = useLogout();
  // const { data: user } = useGetIdentity() as unknown as IUser;

  return (
    <div>
      <button
        ref={ref}
        onClick={() => setOpensidebar(!opensidebar)}
        type='button'
        className='inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 border border-slate-400 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 '>
        <svg
          className='w-6 h-6'
          aria-hidden='true'
          fill='currentColor'
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            clipRule='evenodd'
            fillRule='evenodd'
            d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'></path>
        </svg>
      </button>

      <aside
        className={
          opensidebar
            ? 'fixed top-0 left-0 z-40 w-64 h-screen transition-transform'
            : 'fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full md:translate-x-0'
        }>
        <div className='h-full px-3 py-4 overflow-y-auto sidebar'>
          <div className='flex justify-end md:hidden'>
            <button onClick={() => setOpensidebar(false)}>
              <IoMdClose className='text-3xl ' />
            </button>
          </div>
          <Link to='/dashboard'>
            <img src={logo} alt='Future Analytics Logo' className='mb-4 p-2' />
          </Link>
          <ul className='space-y-2 font-medium'>
            <li>
              <NavLink
                to='/dashboard'
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center p-2 text-blue-400 rounded-lg bg-gray-50 '
                    : 'flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 '
                }>
                <AiOutlineHome className='text-3xl' />

                <span className='flex-1 ml-3 whitespace-nowrap'>Home</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/project'
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center p-2 text-blue-400 rounded-lg bg-gray-50 '
                    : 'flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 '
                }>
                <svg
                  width='20'
                  height='21'
                  viewBox='0 0 20 21'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-6 h-6 text-gray-50 transition duration-75'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.41473 0.0791796C9.62587 -0.0263932 9.8744 -0.0263932 10.0855 0.0791796L19.0855 4.57918C19.3396 4.70622 19.5001 4.96592 19.5001 5.25C19.5001 5.53408 19.3396 5.79378 19.0855 5.92082L10.0855 10.4208C9.8744 10.5264 9.62587 10.5264 9.41473 10.4208L0.414726 5.92082C0.160638 5.79378 0.000136639 5.53408 0.000136639 5.25C0.000136639 4.96592 0.160638 4.70622 0.414726 4.57918L9.41473 0.0791796ZM2.42719 5.25L9.75014 8.91147L17.0731 5.25L9.75014 1.58853L2.42719 5.25ZM0.0945187 14.3858C0.295679 14.0237 0.752281 13.8932 1.11437 14.0944L9.75014 18.892L18.3859 14.0944C18.748 13.8932 19.2046 14.0237 19.4058 14.3858C19.6069 14.7479 19.4765 15.2045 19.1144 15.4056L10.1144 20.4056C9.88785 20.5315 9.61242 20.5315 9.3859 20.4056L0.385904 15.4056C0.0238166 15.2045 -0.106641 14.7479 0.0945187 14.3858ZM1.11437 9.09438C0.752281 8.89322 0.295679 9.02368 0.0945187 9.38577C-0.106641 9.74786 0.0238167 10.2045 0.385904 10.4056L9.3859 15.4056C9.61242 15.5315 9.88785 15.5315 10.1144 15.4056L19.1144 10.4056C19.4765 10.2045 19.6069 9.74786 19.4058 9.38577C19.2046 9.02368 18.748 8.89322 18.3859 9.09438L9.75014 13.892L1.11437 9.09438Z'
                    fill='#0E2782'
                  />
                </svg>

                <span className='ml-3'>Projects</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='business-glossary'
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center p-2 text-blue-400 rounded-lg bg-gray-50 '
                    : 'flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 '
                }>
                {/* <svg
                  width='23'
                  height='22'
                  viewBox='0 0 23 22'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='flex-shrink-0 w-6 h-6'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.4477 7C9.30946 7 7.48837 8.63209 7.48837 10.75C7.48837 12.8679 9.30946 14.5 11.4477 14.5C13.5859 14.5 15.407 12.8679 15.407 10.75C15.407 8.63209 13.5859 7 11.4477 7ZM8.98837 10.75C8.98837 9.5542 10.041 8.5 11.4477 8.5C12.8544 8.5 13.907 9.5542 13.907 10.75C13.907 11.9458 12.8544 13 11.4477 13C10.041 13 8.98837 11.9458 8.98837 10.75Z'
                    fill='#18191A'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.4477 0C13.5426 0 15.0306 2.04024 14.3904 4.03498C14.3831 4.05763 14.4146 4.07157 14.4265 4.05095L14.539 3.85566C15.5434 2.11199 18.0619 1.76645 19.56 3.1668C21.058 4.56714 20.6884 6.92141 18.823 7.86031C18.8007 7.87154 18.8138 7.90537 18.8379 7.89862L19.0543 7.83794C20.9831 7.29704 22.8953 8.74681 22.8953 10.75C22.8953 12.7532 20.9831 14.203 19.0543 13.6621L18.838 13.6015C18.8139 13.5947 18.8008 13.6285 18.8231 13.6398C20.6884 14.5787 21.0581 16.9329 19.56 18.3333C18.062 19.7336 15.5435 19.3881 14.5391 17.6444L14.4265 17.449C14.4146 17.4284 14.3831 17.4424 14.3904 17.465C15.0306 19.4598 13.5426 21.5 11.4477 21.5C9.35273 21.5 7.86477 19.4598 8.50494 17.465C8.5122 17.4424 8.48077 17.4285 8.46891 17.4491L8.3564 17.6444C7.35199 19.3881 4.83347 19.7336 3.33543 18.3333C1.83739 16.9329 2.20703 14.5787 4.07235 13.6398C4.09467 13.6285 4.08155 13.5947 4.05749 13.6014L3.84108 13.6621C1.91227 14.203 0 12.7533 0 10.75C0 8.74683 1.91227 7.29705 3.84108 7.83796L4.05749 7.89865C4.08154 7.90539 4.09465 7.87158 4.07234 7.86035C2.20702 6.92145 1.83738 4.56718 3.33542 3.16684C4.83346 1.76649 7.35198 2.11203 8.35639 3.8557L8.46887 4.05098C8.48073 4.07156 8.51216 4.05765 8.5049 4.03504C7.86472 2.04027 9.3527 0 11.4477 0ZM11.4477 1.5C10.3695 1.5 9.60367 2.55005 9.93315 3.57667C10.1465 4.24138 9.71251 4.93413 9.05886 5.17927C9.01582 5.19541 8.97302 5.21198 8.93045 5.22896C8.25555 5.49818 7.43791 5.31671 7.07523 4.68708L6.99194 4.54249C6.47968 3.6532 5.19522 3.47698 4.43121 4.19116C3.6672 4.90534 3.85572 6.10604 4.80704 6.58489L4.93759 6.65059C5.5968 6.9824 5.78633 7.82697 5.49364 8.50446C5.21701 9.14478 4.53564 9.5906 3.86402 9.40226L3.43605 9.28224C2.46386 9.0096 1.5 9.74035 1.5 10.75C1.5 11.7597 2.46386 12.4905 3.43605 12.2179L3.86405 12.0978C4.53566 11.9095 5.21703 12.3553 5.49367 12.9956C5.78638 13.6731 5.59684 14.5177 4.93762 14.8495L4.80705 14.9152C3.85573 15.3941 3.66721 16.5948 4.43122 17.3089C5.19523 18.0231 6.47969 17.8469 6.99195 16.9576L7.07529 16.8129C7.43797 16.1833 8.2556 16.0018 8.93049 16.2711C8.97305 16.288 9.01585 16.3046 9.05887 16.3207C9.71254 16.5659 10.1465 17.2587 9.93319 17.9234C9.60373 18.95 10.3695 20 11.4477 20C12.5258 20 13.2916 18.95 12.9622 17.9234C12.7488 17.2586 13.1828 16.5659 13.8365 16.3207C13.8795 16.3045 13.9223 16.288 13.9648 16.271C14.6398 16.0018 15.4574 16.1832 15.8201 16.8129L15.9035 16.9576C16.4158 17.8469 17.7002 18.0231 18.4642 17.309C19.2282 16.5948 19.0397 15.3941 18.0884 14.9152L17.9576 14.8494C17.2984 14.5176 17.1089 13.673 17.4016 12.9956C17.6782 12.3552 18.3596 11.9094 19.0312 12.0978L19.4593 12.2178C20.4315 12.4905 21.3953 11.7597 21.3953 10.75C21.3953 9.74033 20.4315 9.00959 19.4593 9.28223L19.0312 9.40228C18.3596 9.59062 17.6782 9.1448 17.4016 8.50448C17.1089 7.827 17.2984 6.98244 17.9576 6.65063L18.0883 6.58485C19.0397 6.106 19.2282 4.9053 18.4642 4.19112C17.7002 3.47694 16.4157 3.65316 15.9034 4.54245L15.8201 4.68711C15.4574 5.31675 14.6398 5.49822 13.9648 5.22898C13.9223 5.21201 13.8795 5.19545 13.8365 5.17932C13.1828 4.93415 12.7488 4.24136 12.9622 3.57661C13.2916 2.55001 12.5258 1.5 11.4477 1.5Z'
                    fill='#18191A'
                  />
                </svg> */}
                <IoIosList size={23} />

                <span className='flex-1 ml-3 whitespace-nowrap'>
                  Business Glossary
                </span>
              </NavLink>
            </li>

            {/* <button
              type='button'
              className='flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100  '
              aria-controls='dropdown-example'
              data-collapse-toggle='dropdown-example'>
              <svg
                aria-hidden='true'
                className='flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  d='M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z'
                  clipRule='evenodd'></path>
              </svg>
              <button onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}>
                <div className='flex justify-between gap-16'>
                  <span className='flex-1 ml-3 text-left whitespace-nowrap'>
                    E-commerce
                  </span>
                  <svg
                    className='w-6 h-6'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'></path>
                  </svg>
                </div>
              </button>
            </button>
            {isSubmenuOpen && (
              <ul className=' py-2 space-y-2'>
                <li>
                  <Link
                    to='#'
                    className='flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  '>
                    Products
                  </Link>
                </li>
                <li>
                  <Link
                    to='#'
                    className='flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  '>
                    Billing
                  </Link>
                </li>
                <li>
                  <Link
                    to='#'
                    className='flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100  '>
                    Invoice
                  </Link>
                </li>
              </ul>
            )} */}

            {/* <li>
              <NavLink
                to="#"
                className="flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 "
              >
                <svg
                  width="18"
                  height="22"
                  viewBox="0 0 18 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                >
                  <path
                    d="M5 3V3C2.79086 3 1 4.79086 1 7V14.6C1 16.8402 1 17.9603 1.43597 18.816C1.81947 19.5686 2.43139 20.1805 3.18404 20.564C4.03968 21 5.15979 21 7.4 21H10.6C12.8402 21 13.9603 21 14.816 20.564C15.5686 20.1805 16.1805 19.5686 16.564 18.816C17 17.9603 17 16.8402 17 14.6V7C17 4.79086 15.2091 3 13 3V3M5 3V3C5 1.89543 5.89543 1 7 1H11C12.1046 1 13 1.89543 13 3V3M5 3V3C5 3.46466 5 3.69698 5.03843 3.89018C5.19624 4.68356 5.81644 5.30376 6.60982 5.46157C6.80302 5.5 7.03534 5.5 7.5 5.5H10.5C10.9647 5.5 11.197 5.5 11.3902 5.46157C12.1836 5.30376 12.8038 4.68356 12.9616 3.89018C13 3.69698 13 3.46466 13 3V3"
                    stroke="#0E2782"
                    strokeWidth="1.5"
                  />
                </svg>

                <span className="flex-1 ml-3 whitespace-nowrap">Meeting</span>
                <span className="inline-flex items-center justify-center w-3 h-3 p-3 ml-3 text-sm font-medium text-blue-800 bg-blue-200 rounded-full ">
                  3
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="#"
                className="flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 "
              >
                <svg
                  width="24"
                  height="21"
                  viewBox="0 0 24 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                >
                  <path
                    d="M19.3688 11.7137C19.665 12.0033 19.6703 12.4782 19.3807 12.7743L15.9585 16.2743C15.8174 16.4187 15.6241 16.5 15.4223 16.5C15.2204 16.5 15.0271 16.4187 14.886 16.2743L13.4193 14.7743C13.1298 14.4782 13.1351 14.0033 13.4313 13.7137C13.7274 13.4242 14.2023 13.4295 14.4919 13.7257L15.4223 14.6772L18.3082 11.7257C18.5978 11.4295 19.0727 11.4242 19.3688 11.7137Z"
                    fill="#18191A"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.7334 0C3.11005 0 0.983398 2.12665 0.983398 4.75V12.75C0.983398 15.3734 3.11004 17.5 5.7334 17.5H10.8981C12.0824 19.3058 14.099 20.5 16.4 20.5C20.0701 20.5 23.0167 17.4619 23.0167 13.75C23.0167 12.4576 22.6595 11.2469 22.039 10.2177V4.75C22.039 2.12665 19.9123 0 17.289 0H5.7334ZM20.539 8.48292V6H2.4834V12.75C2.4834 14.5449 3.93847 16 5.7334 16H10.1604C9.91613 15.2954 9.78338 14.5379 9.78338 13.75C9.78338 10.0381 12.73 7 16.4 7C17.9701 7 19.4078 7.55601 20.539 8.48292ZM20.5295 4.5H2.49287C2.62053 2.82189 4.02259 1.5 5.7334 1.5H17.289C18.9998 1.5 20.4018 2.82189 20.5295 4.5ZM16.4 8.5C13.59 8.5 11.2834 10.8345 11.2834 13.75C11.2834 16.6655 13.59 19 16.4 19C19.2101 19 21.5167 16.6655 21.5167 13.75C21.5167 10.8345 19.2101 8.5 16.4 8.5Z"
                    fill="#18191A"
                  />
                </svg>

                <span className="flex-1 ml-3 whitespace-nowrap">Billing</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to='account'
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center p-2 text-blue-400 rounded-lg bg-gray-50 '
                    : 'flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 '
                }>
                <svg
                  width='23'
                  height='22'
                  viewBox='0 0 23 22'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  className='flex-shrink-0 w-6 h-6'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.4477 7C9.30946 7 7.48837 8.63209 7.48837 10.75C7.48837 12.8679 9.30946 14.5 11.4477 14.5C13.5859 14.5 15.407 12.8679 15.407 10.75C15.407 8.63209 13.5859 7 11.4477 7ZM8.98837 10.75C8.98837 9.5542 10.041 8.5 11.4477 8.5C12.8544 8.5 13.907 9.5542 13.907 10.75C13.907 11.9458 12.8544 13 11.4477 13C10.041 13 8.98837 11.9458 8.98837 10.75Z'
                    fill='#18191A'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.4477 0C13.5426 0 15.0306 2.04024 14.3904 4.03498C14.3831 4.05763 14.4146 4.07157 14.4265 4.05095L14.539 3.85566C15.5434 2.11199 18.0619 1.76645 19.56 3.1668C21.058 4.56714 20.6884 6.92141 18.823 7.86031C18.8007 7.87154 18.8138 7.90537 18.8379 7.89862L19.0543 7.83794C20.9831 7.29704 22.8953 8.74681 22.8953 10.75C22.8953 12.7532 20.9831 14.203 19.0543 13.6621L18.838 13.6015C18.8139 13.5947 18.8008 13.6285 18.8231 13.6398C20.6884 14.5787 21.0581 16.9329 19.56 18.3333C18.062 19.7336 15.5435 19.3881 14.5391 17.6444L14.4265 17.449C14.4146 17.4284 14.3831 17.4424 14.3904 17.465C15.0306 19.4598 13.5426 21.5 11.4477 21.5C9.35273 21.5 7.86477 19.4598 8.50494 17.465C8.5122 17.4424 8.48077 17.4285 8.46891 17.4491L8.3564 17.6444C7.35199 19.3881 4.83347 19.7336 3.33543 18.3333C1.83739 16.9329 2.20703 14.5787 4.07235 13.6398C4.09467 13.6285 4.08155 13.5947 4.05749 13.6014L3.84108 13.6621C1.91227 14.203 0 12.7533 0 10.75C0 8.74683 1.91227 7.29705 3.84108 7.83796L4.05749 7.89865C4.08154 7.90539 4.09465 7.87158 4.07234 7.86035C2.20702 6.92145 1.83738 4.56718 3.33542 3.16684C4.83346 1.76649 7.35198 2.11203 8.35639 3.8557L8.46887 4.05098C8.48073 4.07156 8.51216 4.05765 8.5049 4.03504C7.86472 2.04027 9.3527 0 11.4477 0ZM11.4477 1.5C10.3695 1.5 9.60367 2.55005 9.93315 3.57667C10.1465 4.24138 9.71251 4.93413 9.05886 5.17927C9.01582 5.19541 8.97302 5.21198 8.93045 5.22896C8.25555 5.49818 7.43791 5.31671 7.07523 4.68708L6.99194 4.54249C6.47968 3.6532 5.19522 3.47698 4.43121 4.19116C3.6672 4.90534 3.85572 6.10604 4.80704 6.58489L4.93759 6.65059C5.5968 6.9824 5.78633 7.82697 5.49364 8.50446C5.21701 9.14478 4.53564 9.5906 3.86402 9.40226L3.43605 9.28224C2.46386 9.0096 1.5 9.74035 1.5 10.75C1.5 11.7597 2.46386 12.4905 3.43605 12.2179L3.86405 12.0978C4.53566 11.9095 5.21703 12.3553 5.49367 12.9956C5.78638 13.6731 5.59684 14.5177 4.93762 14.8495L4.80705 14.9152C3.85573 15.3941 3.66721 16.5948 4.43122 17.3089C5.19523 18.0231 6.47969 17.8469 6.99195 16.9576L7.07529 16.8129C7.43797 16.1833 8.2556 16.0018 8.93049 16.2711C8.97305 16.288 9.01585 16.3046 9.05887 16.3207C9.71254 16.5659 10.1465 17.2587 9.93319 17.9234C9.60373 18.95 10.3695 20 11.4477 20C12.5258 20 13.2916 18.95 12.9622 17.9234C12.7488 17.2586 13.1828 16.5659 13.8365 16.3207C13.8795 16.3045 13.9223 16.288 13.9648 16.271C14.6398 16.0018 15.4574 16.1832 15.8201 16.8129L15.9035 16.9576C16.4158 17.8469 17.7002 18.0231 18.4642 17.309C19.2282 16.5948 19.0397 15.3941 18.0884 14.9152L17.9576 14.8494C17.2984 14.5176 17.1089 13.673 17.4016 12.9956C17.6782 12.3552 18.3596 11.9094 19.0312 12.0978L19.4593 12.2178C20.4315 12.4905 21.3953 11.7597 21.3953 10.75C21.3953 9.74033 20.4315 9.00959 19.4593 9.28223L19.0312 9.40228C18.3596 9.59062 17.6782 9.1448 17.4016 8.50448C17.1089 7.827 17.2984 6.98244 17.9576 6.65063L18.0883 6.58485C19.0397 6.106 19.2282 4.9053 18.4642 4.19112C17.7002 3.47694 16.4157 3.65316 15.9034 4.54245L15.8201 4.68711C15.4574 5.31675 14.6398 5.49822 13.9648 5.22898C13.9223 5.21201 13.8795 5.19545 13.8365 5.17932C13.1828 4.93415 12.7488 4.24136 12.9622 3.57661C13.2916 2.55001 12.5258 1.5 11.4477 1.5Z'
                    fill='#18191A'
                  />
                </svg>

                <span className='flex-1 ml-3 whitespace-nowrap'>Account</span>
              </NavLink>
            </li>
            <li>
              <div className='flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-50 '>
                <button onClick={() => logout()} className='flex'>
                  <svg
                    aria-hidden='true'
                    className='flex-shrink-0 w-6 h-6 text-red-500 transition duration-75 group-hover:text-gray-900'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z'
                      clipRule='evenodd'></path>
                  </svg>
                  <span className='flex-1 ml-3 whitespace-nowrap text-red-500'>
                    Logout
                  </span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </aside>
      {/* <div className='mr-2 flex justify-end py-4 md:mr-8'>
        <div className='p-3 border border-blue-400 rounded-full'>
          {user.email}
        </div>
      </div> */}
      {/* <div className='w-[95%] max-w-[1600px] overflow-x-auto ml-2 md:ml-72'> */}
      <div className='w-[95%] max-w-[1600px] overflow-auto ml-2 md:ml-72'>
        {children}
      </div>
    </div>
  );
};
export default Layout;
